import React from "react";
import PropTypes from "prop-types";

import { Chip, Columns, Modal } from "@namroodinc/ni-ui";

import BarGroup from "../BarGroup.js";
import DonutGroup from "../DonutGroup.js";
import StrikesByZone from "./StrikesByZone.js";

import styles from "../styles.module.scss";

const StatCols = (props) => {
  return (
    <Columns
      numberOfColumns={props.data.length}
      responsive={props.responsive}
      verticalAlignment={"center"}
    >
      {props.data?.map((stat, index) => {
        return (
          <Columns
            gap={"md"}
            key={index}
            numberOfColumns={1}
            verticalAlignment={"center"}
          >
            {stat.label && (
              <span className={styles.statsDetails}>
                <span className={styles.statsDetailsLabel}>{stat.label}</span>
              </span>
            )}
            {stat[props.typeOfValue] && (
              <Chip
                label={stat[props.typeOfValue]}
                color={props[stat.brandColor]}
                backgroundOpacityPreset={
                  stat.highestValue === stat.team &&
                  props.typeOfValue === "notes"
                    ? "medium"
                    : "solid"
                }
                profiling={
                  stat.highestValue === stat.team &&
                  props.typeOfValue === "notes"
                    ? "background"
                    : "border"
                }
              />
            )}
          </Columns>
        );
      })}
    </Columns>
  );
};

StatCols.propTypes = {
  data: PropTypes.array,
  responsive: PropTypes.bool,
  typeOfValue: PropTypes.string,
  homeBrandColor: PropTypes.string,
  awayBrandColor: PropTypes.string
};

StatCols.defaultProps = {
  data: [],
  responsive: false,
  typeOfValue: "percentage",
  homeBrandColor: "",
  awayBrandColor: ""
};

const Round = (props) => {
  return (
    <div className={styles.stats}>
      {props.round.sections?.length > 0 &&
        props.round.sections.map((section, index) => {
          return (
            <div className={styles.statsSection} key={index}>
              <span className={styles.statsSectionHeader}>
                {section.heading}
                {section.meaning && (
                  <Modal
                    openModalButtonLabel="More info"
                    openModalCardProps={{
                      headline: section.heading
                    }}
                  >
                    <span>{section.meaning}</span>
                  </Modal>
                )}
              </span>
              {section.sections?.length > 0 &&
                section.sections.map((subSection, subIndex) => {
                  return (
                    <div className={styles.statsSectionSection} key={subIndex}>
                      <span className={styles.statsSectionSectionHeader}>
                        {subSection.heading}
                      </span>
                      <div className={styles.statsSectionSectionContents}>
                        {!Array.isArray(subSection.data) ? (
                          <>
                            {subSection.data.visualType === "barGroup" && (
                              <BarGroup
                                label={subSection.data.label}
                                typeOfValue={props.typeOfValue}
                                {...subSection.data.data}
                                {...props.data.homeAndAwayBrandColors}
                              />
                            )}
                            {subSection.data.visualType === "donutGroup" && (
                              <DonutGroup
                                label={subSection.data.label}
                                typeOfValue={props.typeOfValue}
                                {...subSection.data.data}
                                {...props.data.homeAndAwayBrandColors}
                              />
                            )}
                            {subSection.data.visualType === "statCols" && (
                              <StatCols
                                data={subSection.data.data}
                                responsive={section.responsive || false}
                                typeOfValue={props.typeOfValue}
                                {...props.data.homeAndAwayBrandColors}
                              />
                            )}
                            {subSection.data.visualType ===
                              "strikesByZones" && (
                              <StrikesByZone
                                data={subSection.data.data}
                                gender={props.event.gender}
                                typeOfValue={props.typeOfValue}
                                {...props.data.homeAndAwayBrandColors}
                              />
                            )}
                          </>
                        ) : (
                          <Columns numberOfColumns={1}>
                            {subSection.data.map((data, dataIndex) => {
                              return (
                                <div key={dataIndex}>
                                  {data.visualType === "barGroup" && (
                                    <BarGroup
                                      label={data.label}
                                      typeOfValue={props.typeOfValue}
                                      {...data.data}
                                      {...props.data.homeAndAwayBrandColors}
                                    />
                                  )}
                                </div>
                              );
                            })}
                          </Columns>
                        )}
                      </div>
                    </div>
                  );
                })}
            </div>
          );
        })}
    </div>
  );
};

Round.propTypes = {
  data: PropTypes.object,
  event: PropTypes.object,
  round: PropTypes.object,
  typeOfValue: PropTypes.string
};

Round.defaultProps = {
  data: {
    eventGender: "",
    homeAndAwayBrandColors: {
      homeBrandColor: "",
      awayBrandColor: ""
    }
  },
  event: {
    gender: "male"
  },
  round: {
    totalStrikes: {},
    strikesByZones: {}
  },
  typeOfValue: "percentage"
};

export default Round;
